import {merge, cloneDeep} from 'lodash';
import {createImageObject} from '@/store/utils';
import * as marketFormater from '@/views/ImageCreate/utils/formate';
import {defaultFormData, placeHolder, maxUploadNum} from '@/views/V2/image/stitching/utils/constants';
import {getImagePositionInfo} from '@/views/V2/image/stitching/utils/format.js';

export default {
    namespaced: true,
    state: {
        title: '多图拼接',
        placeHolder,
        maxUploadNum,
        displayImg: [],
        recordImg: [],
        toolBarLoading: false,
        formData: cloneDeep(defaultFormData),
        canSubmit: true,
        sizeValidate: true,
        historyParams: {
            pageNo: 1,
            pageSize: 10,
            taskType: [17]
        },
        pageLoadingStatus: {
            show: false,
            title: ''
        },
        uploadImg: []
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_FORM_DATA(state, {form, key, value}) {
            state[form] = {...state[form], [key]: value};
        },
        CHANGE_FORM_DATA(state, data) {
            state.formData = merge(state.formData, data);
        },
        CHANGE_CAN_SUBMIT(state, data) {
            state.canSubmit = data;
        },
        CHANGE_SIZE_VALIDATE(state, data) {
            state.sizeValidate = data;
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        }
    },
    actions: {
        changeFormData({commit}, data) {
            commit('CHANGE_FORM_DATA', data);
        },
        updateFormData({commit}, data) {
            const {key, value} = data;
            commit('UPDATE_FORM_DATA', {
                form: 'formData',
                key,
                value
            });
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        changeFormSubmit({commit}, data) {
            commit('CHANGE_CAN_SUBMIT', Boolean(data.length));
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        resetFromData({commit}) {
            const value = cloneDeep(defaultFormData);
            commit('UPDATE_COMMON_STATE', {
                key: 'formData',
                value
            });
            commit('CHANGE_TOOLBAR_LOADING', false);
        },
        resetState({dispatch, commit}) {
            dispatch('resetFromData');
            dispatch('changeDisplayImg', []);
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    const recordList = i.records;
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片拼接按钮提交
        async handleStitchingSubmit({commit, state}, {model, data}) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const baseDisplayImg = Array.from({
                    length: data.targetCount
                }, (_, i) => createImageObject({
                    recordId: i
                }));
                commit('CHANGE_DISPLAY_IMG', baseDisplayImg);

                const {layoutNum, uploadList, itemSize, space, targetCount, imageGenerateType} = data;

                const canvasStyle = {
                    height: data.height,
                    width: data.width
                };

                let mergeGroups = [];

                // 选择多张图片，合成多张图片，需要先按顺序进行分组，分配给每张图片用的拼接源
                let groupImageList = [];
                uploadList.forEach((imageItem, index) => {
                    const sizeParam = itemSize[index % layoutNum];
                    const imageInfo = getImagePositionInfo({
                        sizeParam,
                        imageItem,
                        space,
                        canvasStyle
                    });
                    groupImageList.push(imageInfo);
                    // 如果本组已经够数了，push记录，然后清空，继续下一组
                    if (groupImageList.length === layoutNum) {
                        mergeGroups.push(groupImageList);
                        groupImageList = [];
                    }
                });
                // 对每一组图片，进行拼接合成的动作，组合出多个合成结果
                const mergeImagesResult = await Promise.all(
                    mergeGroups.map(async groupImageList => {
                        let groupInfo = await model.imageCreate.renderImagesByCanvas(canvasStyle, groupImageList);
                        groupInfo.editorParams = JSON.stringify({
                            itemSize,
                            space,
                            canvasStyle,
                            imageList: groupImageList
                        });
                        return groupInfo;
                    })
                );
                if (mergeImagesResult.length < 1) {
                    throw new Error();
                }
                // 对这批图片生成结果，调用后端接口存储起来
                const taskParams = {
                    ...canvasStyle,
                    targetCount,
                    imageGenerateType,
                    extraParams: {
                        formData: state.formData
                    }
                };
                const saveInfoList = marketFormater.handleSaveInfo(mergeImagesResult, taskParams);
                const infoList = await model.imageCreate.insertGenMarketPicture(saveInfoList);

                const displayImg = infoList.map(item => createImageObject(item));

                commit('CHANGE_DISPLAY_IMG', displayImg);
            }
            catch (err) {
                commit('CHANGE_DISPLAY_IMG', []);
                throw err;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        },
        // 修改了某张图片的调整拼接顺序等，需要重新合成图片 ，然后更新结果区的信息
        async changeSourceImageList({commit, state}, {model, recordInfo, imageList, index}) {
            // 根据调整后的图片list，合成新的图片，并更新record，更新结果区，更新历史区
            const {height, width, recordId} = recordInfo;
            const canvasStyle = {
                height,
                width
            };
            const editorParamsObj = JSON.parse(recordInfo.editorParams);
            const {itemSize, space} = editorParamsObj;
            // 重新计算每个图片的坐标信息
            const newImageList = imageList.map((imageItem, index) => {
                const sizeParam = itemSize[index];
                return getImagePositionInfo({
                    sizeParam,
                    imageItem,
                    space,
                    canvasStyle
                });
            });
            let editorParams = JSON.parse(recordInfo.editorParams);
            editorParams.imageList = newImageList;
            const newInfo = await model.imageCreate.renderImagesByCanvas(canvasStyle, newImageList);
            const newUrl = newInfo.url;
            let updateRecord = {
                recordId,
                editorParams: JSON.stringify(editorParams),
                url: newUrl
            };
            // 更新record、然后更新结果和历史
            model.imageCreate.updateCutoutRecord({
                recordList: [updateRecord]
            });
            recordInfo.url = newUrl;
            recordInfo.editorParams = updateRecord.editorParams;

            const nowDisplayImg = state.displayImg;
            nowDisplayImg[index].url = newUrl;
            nowDisplayImg[index].editorParams = updateRecord.editorParams;
            commit('CHANGE_DISPLAY_IMG', nowDisplayImg);
        },
        async handleImagePickerConfirm({dispatch, commit, state}, info) {
            const {imageList, change = false} = info;
            const uploadImg = imageList.map(item => ({
                url: item.url,
                width: item.width,
                height: item.height
            }));
            let allUploadImg = [];
            if (change) {
                // 整个更换上传图片列表
                allUploadImg = uploadImg;
            }
            else {
                // 增加图片
                const oriuploadList = state.formData.stitchTargetCount?.uploadList || [];
                allUploadImg = oriuploadList.concat(uploadImg);
            }
            dispatch('updateFormData', {
                key: 'stitchTargetCount',
                value: {
                   ...state.formData.stitchTargetCount,
                   uploadList: allUploadImg
                }
            });
        }
    }
  };
